import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postShifts } from '../../../../MyApi/sb/shifts'


import PageHeader from '../../../../Components/UI/PageHeader'
import AddShift from '../../../../Components/sb/shifts/shiftsStore/AddShift'



const ShiftsStore = () => {
const [shiftName ,setshiftName]= useState("")
const [companyId ,setCompanyId]= useState("")
const [active ,setActive] =useState(1)
const [flexible ,setFlexible] =useState(1)
const [breakTime ,setBreakTime] =useState(1)

const initialWeekData = [
   { day: "Saturday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Sunday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null ,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0},
   { day: "Monday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0},
   { day: "Tuesday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Wednesday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null, flexible: 0, break: 1, day_off: 0},
   { day: "Thursday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Friday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
 ];
 const [weeksData, setWeekData] = useState(initialWeekData);

 const mutation = useMutation("postshifts" , (postData)=>postShifts(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setWeekData(initialWeekData)
        setshiftName("")
        setActive(false)
        setFlexible(false)
        setBreakTime(false)
    },
    onError :(error)=>{
       toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:shiftName,     
        sb_company_id:+companyId,
        flexible,
        break:breakTime,
        active,
        days:weeksData
    })
 }
 const isDisabled= ()=>{
   return !(shiftName && companyId )
 }
  return ( 

    <div>
        <PageHeader title="Add shift"  showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
  
        <AddShift shiftName={shiftName}  setCompanyId={setCompanyId} setshiftName={setshiftName}    setActive={setActive} setFlexible={setFlexible} setBreakTime={setBreakTime}  active={active} flexible={flexible} breakTime={breakTime} setWeekData={setWeekData} weeksData={weeksData}  />
    </div>
  )
}

export default ShiftsStore